import { BoxProps, Flex, HelpIcon, Placement, useTooltip } from "@pancakeswap/uikit";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props extends BoxProps {
  text: string | React.ReactNode;
  placement?: Placement;
  size?: string;
  color?: string;
}

interface TooltipProps extends BoxProps {
  text: string | React.ReactNode;
  placement?: Placement;
  size?: string;
  color?: string;
  handler: ReactNode | string;
}

const QuestionWrapper = styled.div`
  :hover,
  :focus {
    opacity: 0.7;
  }
`;

const BaseTooltip = styled.div`
  .handler {
    border-bottom: 1px dotted rgba(255, 255, 255, 0.6);
  }
  display: flex;
  align-items: center;
`;

export const QuestionHelper: React.FC<React.PropsWithChildren<Props>> = ({
  text,
  placement = "right-end",
  size = "16px",
  color,
  ...props
}) => {
  const { targetRef, tooltip, tooltipVisible } = useTooltip(text, { placement });

  return (
    <Flex alignItems="center" {...props} ref={targetRef}>
      {tooltipVisible && tooltip}
      <QuestionWrapper as={Flex} alignItems="center">
        <HelpIcon color={color || "textSubtle"} width={size} />
      </QuestionWrapper>
    </Flex>
  );
};

export const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = ({
  text,
  placement = "right-end",
  handler,
  ...props
}) => {
  const { targetRef, tooltip, tooltipVisible } = useTooltip(text, { placement });

  return (
    <BaseTooltip {...props} ref={targetRef}>
      <>
        {tooltipVisible && tooltip}
        <div className="handler">{handler}</div>
      </>
    </BaseTooltip>
  );
};
